import React, { useEffect, useState } from "react";
import { Sparkles, X, ArrowRight } from "lucide-react";

/** Sticky right-side floating banner with Neukunden-Rabatt. Hides after dismiss; collapses on mobile. */
export default function StickyDiscount() {
    const [open, setOpen] = useState(true);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            // Show after user scrolls 600px from top, hide near bottom (footer reached)
            const y = window.scrollY;
            const max = document.documentElement.scrollHeight - window.innerHeight - 400;
            setVisible(y > 600 && y < max);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!open) return null;

    return (
        <div
            className={`fixed right-3 top-1/2 -translate-y-1/2 z-40 transition-all duration-500 ease-out ${visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8 pointer-events-none"}`}
            data-testid="sticky-discount-banner"
        >
            <a
                href="#offer"
                className="group relative flex flex-col items-center gap-2 bg-[#16A34A] text-white rounded-2xl shadow-2xl shadow-[#16A34A]/30 px-3 py-4 hover:bg-[#15803D] transition-colors w-[78px] sm:w-[88px]"
            >
                <button
                    onClick={(e) => { e.preventDefault(); setOpen(false); }}
                    aria-label="Banner schliessen"
                    className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-white text-slate-500 hover:text-[#1A365D] flex items-center justify-center shadow-md"
                    data-testid="sticky-discount-close"
                >
                    <X className="w-3.5 h-3.5" />
                </button>
                <Sparkles className="w-5 h-5" />
                <div className="text-[9px] font-bold uppercase tracking-widest leading-tight text-center">Neukunden-Rabatt</div>
                <div className="text-[10px] font-semibold opacity-80 line-through">CHF 200</div>
                <div className="font-display font-black text-xl leading-none">120</div>
                <div className="text-[8px] uppercase tracking-wider opacity-80">CHF</div>
                <ArrowRight className="w-3.5 h-3.5 mt-1 group-hover:translate-x-0.5 transition-transform" />
            </a>
        </div>
    );
}
